// Eenvoudige API helper. Vervang fetch door jullie http-wrapper indien gewenst.
import http from "../api/apiClient";

const BASE = "/api/v1";

async function json(res) {
  if (res.status === 204) return null;
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(text || `HTTP ${res.status}`);
  }
  return res.json();
}

export async function getMyDirectoryProfile() {
  const res = await fetch(`${BASE}/me/directory-profile`, { credentials: "include" });
  return json(res); // kan null zijn (204)
}

export async function upsertMyDirectoryProfile(body) {
  const res = await fetch(`${BASE}/me/directory-profile`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify(body),
  });
  return json(res);
}

export async function deleteMyDirectoryProfile() {
  const res = await fetch(`${BASE}/me/directory-profile`, {
    method: "DELETE",
    credentials: "include",
  });
  if (!res.ok && res.status !== 204) throw new Error(`HTTP ${res.status}`);
}

export async function searchDirectory({ q = "", page = 0, size = 25 }) {
  const params = new URLSearchParams();
  if (q) params.set("q", q);
  params.set("page", String(page));
  params.set("size", String(size));
  const res = await fetch(`${BASE}/directory?` + params.toString(), { credentials: "include" });
  return json(res);
}

// Staff (non-admin) directory search (axios baseURL, bearer token)
export async function staffSearchDirectory({ q = "", page = 0, size = 25, by = "both" }) {
  const { data } = await http.get("/directory", {
    params: { q, page, size, by },
  });
  return data;
}

// Admin gedeelte
export async function adminSearchDirectory({ q = "", page = 0, size = 25, by = "both" }) {
  const { data } = await http.get("/admin/directory", {
    params: { q, page, size, by }
  });
  return data;
}

// Admin – update (nieuw): published + velden (wel/niet delen)
// Backend: maak een endpoint PUT /api/v1/admin/directory/{parentId}
export async function adminUpdateDirectoryProfile(parentId, body) {
  const { data } = await http.put(`/admin/directory/${parentId}`, body);
  return data;
}
